import { Image } from "expo-image"
import { View } from "react-native"
import BackflipLogo from "@/assets/logo/backflip-logo.svg"
import { HDisplay } from "@/components/standard/BFText"
import { TealifyText } from "@/components/TealifyText"

const imageUrl =
  "https://imagedelivery.net/YGzZH56Oa66tuexCFiV24Q/8a6e641c-7a6c-48a4-c66e-9b17695b6500/height=600"

export const PreQualLandingHeader = ({
  text,
  height = 325,
}: {
  text: string
  height?: number
}) => (
  <View style={{ height }} className={`w-full relative mb-7`}>
    <Image
      source={{ uri: imageUrl }}
      style={{ position: "absolute", width: "100%", height: "100%" }}
    />
    <View className={"absolute top-5 left-5"}>
      <BackflipLogo />
    </View>
    <HDisplay
      className={"text-off-white p-5 absolute bottom-[-40px] inset-x-0"}
    >
      <TealifyText text={text} />
    </HDisplay>
  </View>
)
